const formatProgressCount = (value: number | null | undefined, locale: string): string => {
  const safeValue = value ?? 0;
  return new Intl.NumberFormat(locale).format(safeValue);
};

export default formatProgressCount;
